import React, { useRef, useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Avatar } from "@mui/material";
import DropdownTwo from "../../components/DropDown2";
import Modal from "../../components/Modal";
import DateRangeSelector from "../../components/DateRangePicker";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { axios } from "../../utils/axios";
import SearchLocation from "../../components/LocationSearchByGoogle";
import { toast } from "react-toastify";
import IMGUP from "../../assets/images/trip/uptrip.png";
import IMGPAST from "../../assets/images/trip/past.png";
import IMGBOOKING from "../../assets/images/trip/booked-trip.png";
import Upload from "../../assets/icons/upload.png";
import Loader from "../../components/Loader";
import { formatDateToEEE_MM_d } from "../../utils/utils";
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Alltrips = () => {
  const [value, setValue] = useState(3);
  const navigate = useNavigate();
  const brbref = useRef(null);
  const allref = useRef(null);
  const finishref = useRef(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [tripName, setTripName] = useState();
  const [userName, setUserName] = useState();
  const [tripImg, setTripImg] = useState(null);
  const [dateRange, setDateRange] = useState([
    // {
    //   startDate: addMonths(new Date(), 2),
    //   endDate: addDays(addMonths(new Date(), 2), 7),
    //   key: "selection",
    // },
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selected, setSelected] = useState();
  const [openCountries, setOpenCountries] = useState(false);
  const [bookedTrips, setBookedtrips] = useState([]);
  const [plannedTrips, setPlannedTrips] = useState([]);
  const [pastTrips, setPastTrips] = useState([]);
  const [location, setLocation] = useState();
  const [loader, setLoader] = useState(false);
  const [edit, setEdit] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setTripName("");
    setUserName("");
    setTripImg("");
    setDateRange([{ startDate: null, endDate: null, key: "selection" }]);
    setEdit(false);
  };
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeCountires = (event, newValue) => {
    const inputValue = newValue ? newValue.label : event.target.value;
    setSelectedCountry(inputValue);
    setOpenCountries(false);
  };
  const handleDateRangeChange = (range) => {
    setDateRange(range);
  };
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND + "trip/getusertrips")
      .then((resp) => {
        setBookedtrips(resp.data.data.booked);
        setPlannedTrips(resp.data.data.planning);
        setPastTrips(resp.data.data.past);
      })
      .catch((err) => console.log(err));
  }, []);

  const countries = [
    { name: "United States" },
    { name: "Canada" },
    { name: "Mexico" },
    { name: "Brazil" },
    { name: "Argentina" },
    { name: "United Kingdom" },
    { name: "Germany" },
    { name: "France" },
    { name: "Italy" },
    { name: "Spain" },
    { name: "Australia" },
    { name: "New Zealand" },
    { name: "Japan" },
    { name: "China" },
    { name: "India" },
    { name: "South Korea" },
    { name: "Russia" },
    { name: "South Africa" },
    { name: "Egypt" },
    { name: "Nigeria" },
  ];
  const brbBody = () => {
    return (
      <div>
        <p className="mb-2">Browse by trips</p>
        <p className="mb-2">Browse by bookings</p>
      </div>
    );
  };
  const allBody = () => {
    return (
      <div>
        <p className="mb-2">All</p>
        <p className="mb-2">Business</p>
        <p className="mb-2">Personal</p>
      </div>
    );
  };
  const actions = [
    {
      label: "Cancel",
      onClick: handleClose,
      color: "btn-outlined",
    },
    {
      label: edit === false ? "Create" : "Submit",
      onClick: () => {
        handleSubmit();
      },
      color: "btn-contained",
    },
  ];
  const finishBody = (data) => {
    const handleEditClick = (e) => {
      finishref.current.close();
      e.stopPropagation();
      setSelected(data);
      setOpen(true);
      setTripName(data?.tripName);
      setTripImg(data?.locationImg);
      // setLocation(data.location);
      setDateRange([
        {
          startDate: parseISO(data?.startDate.split("T")[0]),
          endDate: parseISO(data?.endDate.split("T")[0]),
          key: "selection",
        },
      ]);
      setEdit(true);
    };

    const handleDeleteClick = (e) => {
      setSelected(data);
      setDeleteOpen(true);
      finishref.current.close();
    };
    return (
      <div className="m-0 p-0">
        <div
          className="d-flex align-items-center  px-4 py-2 drp-options"
          style={{ gap: 10 }}
          onClick={handleEditClick}
        >
          <EditIcon sx={{ width: 20 }} />
          <p>Edit trip</p>
        </div>
        {value !== 2 && (
          <div
            className="d-flex align-items-center my-2  px-4 py-2 drp-options "
            style={{ gap: 10 }}
            onClick={handleDeleteClick}
          >
            <DeleteIcon sx={{ width: 20 }} />
            <p>Delete trip</p>
          </div>
        )}
      </div>
    );
  };
  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("tripName", tripName);
    formData.append(
      "startDate",
      format(new Date(dateRange[0]?.startDate), "yyyy-MM-dd")
    );
    formData.append(
      "endDate",
      format(new Date(dateRange[0]?.endDate), "yyyy-MM-dd")
    );
    formData.append("location", location?.name);
    formData.append(
      "geoLocation",
      JSON.stringify({
        lat: location?.geometry?.location.lat(),
        lng: location?.geometry?.location.lng(),
      })
    );
    formData.append(
      "locationImg",
      location?.photos !== null && location?.photos !== undefined
        ? location?.photos[0]?.getUrl()
        : ""
    );
    formData.append("Status", "planning");
    formData.append("tripImg", tripImg); //
    if (edit) {
      setLoader(true);
      formData.append("tripid", selected._id);
      axios
        .put(process.env.REACT_APP_BACKEND + "trip/updatetrip", formData)
        .then((resp) => {
          // handleClose();
          setBookedtrips(resp?.data?.data?.booked);
          setPlannedTrips(resp?.data?.data?.planning);
          setPastTrips(resp?.data?.data?.past);
          setTripName("");
          setUserName("");
          setLocation(null);
          setTripImg("");
          handleClose();
          toast.success(resp.data.message);
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
        });
    } else {
      if (!tripName) {
        toast.error("Please enter trip name");
        return;
      } else if (!location) {
        toast.error("Please select Destination");
        return;
      } else if (!dateRange[0]?.startDate || !dateRange[0]?.endDate) {
        toast.error("Please select Dates for the trip");

        return;
      }
      setLoader(true);
      axios
        .post(process.env.REACT_APP_BACKEND + "trip/addtrip", formData)
        .then((resp) => {
          handleClose();
          setBookedtrips(resp.data.data.trips.booked);
          setPlannedTrips(resp.data.data.trips.planning);
          setPastTrips(resp.data.data.trips.past);
          setTripName("");
          setUserName("");
          setTripImg("");
          setLocation(null);
          handleClose();
          toast.success(resp.data.message);
          setLoader(false);
          setValue(3);
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
        });
    }
  };
  const deleteTrip = () => {
    setLoader(true);
    axios
      .delete(
        process.env.REACT_APP_BACKEND + `trip/deletetrip?tripid=${selected._id}`
      )
      .then((resp) => {
        setBookedtrips(resp.data.data.booked);
        setPlannedTrips(resp.data.data.planning);
        setPastTrips(resp.data.data.past);
        setDeleteOpen(false);
        toast.success(resp.data.message);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  const handlePlaceSelect = (place) => {
    setLocation(place);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setTripImg(file);
      // setProfileImageUrl(URL.createObjectURL(file));
    }
  };

  return (
    <div className="bgsearch" style={{ minHeight: "100vh" }}>
      {loader && <Loader />}
      <div className="container p-5 w60">
        <div className="tabContainer">
          <Tabs value={value} onChange={handleChangeTab}>
            <Tab label="Past" {...a11yProps(0)} value={1} />
            <Tab label="Booked" {...a11yProps(1)} value={2} />
            <Tab label="Planning" {...a11yProps(2)} value={3} />
          </Tabs>

          <button className="btn-contained" onClick={handleOpen}>
            New Trip
          </button>
        </div>
        {value == 1 && (
          <>
            {pastTrips.length === 0 ? (
              <div className="t-center mt-5">
                <img src={IMGPAST} loading="lazy" alt="" />
                <p>No past trips</p>
              </div>
            ) : (
              <div className="mt-4">
                {pastTrips.map((uplidata) => (
                  <div
                    key={uplidata._id}
                    className="row bxShadow  mb-0 cardcont mx-auto sclistcard alltripscardheight c-pointer  "
                    onClick={() => navigate(`/trip-planner?id=${uplidata._id}`)}
                    style={{ overflow: "hidden" }}
                  >
                    <div className="col-md-4  m-0 p-0">
                      <img
                        src={uplidata.locationImg}
                        className="imgclass"
                        style={{
                          borderTopLeftRadius: "10px",
                          borderBottomLeftRadius: "10px",
                          objectFit: "cover",
                          height: "13rem",
                        }}
                        loading="lazy"
                        alt=""
                      />
                    </div>
                    <div className="col-md-8 p-4 ">
                      <div className="d-flex  justify-content-between">
                        <div>
                          <div className="d-flex align-items-center mb-3">
                            <p className="me-1 label-color ">
                              {formatDateToEEE_MM_d(uplidata?.startDate, "UTC")}
                            </p>{" "}
                            -
                            <p className="ms-1 label-color ">
                              {formatDateToEEE_MM_d(uplidata?.endDate, "UTC")}
                            </p>
                          </div>
                          <h2 className="mb-3">{uplidata?.tripName}</h2>
                          <div className="d-flex align-items-center">
                            <Avatar
                              alt="Shubham"
                              sx={{ width: 30, height: 30 }}
                            />
                            <p className="ms-2 fs-8">
                              {uplidata?.username}{" "}
                              {uplidata?.travelers?.length !== 0 && (
                                <span className="ms-1">
                                  +{uplidata?.travelers?.length}
                                </span>
                              )}
                            </p>
                          </div>
                        </div>
                        <div style={{ alignSelf: "end" }}>
                          <DropdownTwo
                            title="Options"
                            ref={finishref}
                            bodyContent={finishBody(uplidata)}
                            style={{
                              // width: "50%",
                              titleColor: "#2ecc71",
                              outerdivborderRadius: "6px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
        {value == 2 && (
          <>
            {bookedTrips && bookedTrips.length === 0 ? (
              <div className="t-center mt-5">
                <img src={IMGBOOKING} loading="lazy" alt="" />
                <p>No booked trips </p>
              </div>
            ) : (
              <div className="mt-4">
                {bookedTrips.map((uplidata) => (
                  <div
                    key={uplidata._id}
                    className="row bxShadow  mb-0 cardcont mx-auto  sclistcard c-pointer  alltripscardheight"
                    onClick={() => navigate(`/trip-planner?id=${uplidata._id}`)}
                    style={{ overflow: "hidden" }}
                  >
                    <div className="col-md-4  m-0 p-0">
                      <img
                        src={uplidata.locationImg}
                        className="imgclass"
                        style={{
                          borderTopLeftRadius: "10px",
                          borderBottomLeftRadius: "10px",
                          objectFit: "cover",
                          height: "13rem",
                        }}
                        loading="lazy"
                        alt=""
                      />
                    </div>
                    <div className="col-md-8 p-4 ">
                      <div className="d-flex  justify-content-between">
                        <div>
                          <div className="d-flex align-items-center mb-3">
                            <p className="me-1 label-color ">
                              {formatDateToEEE_MM_d(uplidata?.startDate, "UTC")}
                            </p>{" "}
                            -
                            <p className="ms-1 label-color ">
                              {formatDateToEEE_MM_d(uplidata?.endDate, "UTC")}
                            </p>
                          </div>
                          <h2 className="mb-3">{uplidata.tripName}</h2>
                          <div className="d-flex align-items-center">
                            <Avatar
                              alt="Shubham"
                              sx={{ width: 30, height: 30 }}
                            />
                            <p className="ms-2 fs-8">
                              {uplidata.username}{" "}
                              {uplidata?.travelers?.length !== 0 && (
                                <span className="ms-1">
                                  +{uplidata?.travelers?.length}
                                </span>
                              )}
                            </p>
                          </div>
                        </div>
                        <div style={{ alignSelf: "end" }}>
                          <DropdownTwo
                            title="Options"
                            ref={finishref}
                            bodyContent={finishBody(uplidata)}
                            style={{
                              // width: "100%",
                              titleColor: "#2ecc71",
                              outerdivborderRadius: "6px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
        {value == 3 && (
          <>
            {plannedTrips && plannedTrips.length === 0 ? (
              <div className="t-center mt-5">
                <img src={IMGUP} loading="lazy" alt="" />
                <p>No planned trips</p>
              </div>
            ) : (
              <div className="mt-4">
                {plannedTrips.map((uplidata) => (
                  <div
                    key={uplidata._id}
                    className="row bxShadow  mb-0 cardcont mx-auto sclistcard alltripscardheight c-pointer"
                    onClick={() => navigate(`/trip-planner?id=${uplidata._id}`)}
                  >
                    <div className="col-md-4  m-0 p-0">
                      <img
                        src={uplidata.locationImg}
                        className="imgclass"
                        style={{
                          borderTopLeftRadius: "10px",
                          borderBottomLeftRadius: "10px",
                          objectFit: "cover",
                          height: "13rem",
                        }}
                        loading="lazy"
                        alt=""
                      />
                    </div>
                    <div className="col-md-8 p-4 ">
                      <div className="d-flex  justify-content-between">
                        <div>
                          <div className="d-flex align-items-center mb-3">
                            <p className="me-1 label-color ">
                              {/* {format(
                                new Date(uplidata?.startDate),
                                "EEE MMM d"
                              )} */}
                              {formatDateToEEE_MM_d(uplidata?.startDate, "UTC")}
                            </p>{" "}
                            -
                            <p className="ms-1 label-color ">
                              {/* {format(new Date(uplidata?.endDate), "EEE MMM d")} */}
                              {formatDateToEEE_MM_d(uplidata?.endDate, "UTC")}
                            </p>
                          </div>
                          <h2 className="mb-3">{uplidata.tripName}</h2>
                          <div className="d-flex align-items-center">
                            <Avatar
                              alt={uplidata?.userId?.name}
                              sx={{ width: 30, height: 30 }}
                              src={uplidata?.userId?.picture}
                            />
                            <p className="ms-2 fs-8">
                              {uplidata?.userId?.name}{" "}
                              {uplidata?.travelers?.length !== 0 && (
                                <span className="ms-1">
                                  +{uplidata?.travelers?.length}
                                </span>
                              )}
                            </p>
                          </div>
                        </div>
                        <div style={{ alignSelf: "end" }}>
                          <DropdownTwo
                            title="Options"
                            ref={finishref}
                            bodyContent={finishBody(uplidata)}
                            style={{
                              // width: "120%",
                              titleColor: "#2ecc71",
                              outerdivborderRadius: "6px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        title={edit === true ? "Edit Trip" : "New Trip"}
        actions={actions}
        size="sm"
      >
        <div className="d-flex align-items-center my-4 newtripinpcont ">
          <p className="px-3 fs-8">
            Trip Name <span style={{ color: "var(--red-color)" }}>*</span>
          </p>
          <input
            className="newtripinp"
            onChange={(e) => setTripName(e.target.value)}
            value={tripName}
          />
        </div>
        <div>
          <div className="my-4">
            <DateRangeSelector
              onDateRangeChange={handleDateRangeChange}
              fromChild={dateRange}
              style={{ left: "auto", top: "16%" }}
              trip={true}
            />
          </div>

          <div className="my-2">
            <SearchLocation
              onPlaceSelect={() => console.log()}
              onselect={handlePlaceSelect}
              styles={{
                border: "1px solid var(--light-grey)",
                height: "20px",
                width: "96%",
              }}
              defaultValue={location}
            />
          </div>

          <div
            className="mt-4 d-flex justify-content-between align-items-center"
            style={{
              textAlign: "center",
              position: "relative",
            }}
          >
            {tripImg ? (
              <div
                style={{
                  borderRadius: "12px",
                  position: "relative",
                  cursor: "pointer",
                  backgroundImage:
                    typeof tripImg === "string"
                      ? `url(${tripImg})`
                      : `url(${URL.createObjectURL(tripImg)})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  width: "100%",
                  height: "200px",
                }}
                className="imgupload bxShadow"
              >
                <div
                  className="hover-overlay"
                  onClick={() => document.getElementById("upload").click()}
                >
                  <img
                    src={Upload}
                    alt="upload"
                    style={{ width: "50px", color: "#fff" }}
                    loading="lazy"
                  />
                </div>
                {/* <p className="mb-3 fs-6 text-center">{tripImg?.name}</p> */}
              </div>
            ) : (
              <label
                htmlFor="upload"
                style={{
                  border: "2px dashed var(--light-grey)",
                  cursor: "pointer",
                  width: "100%",
                  padding: "1rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: "8px",
                  textAlign: "center",
                }}
                className="w100 p-4"
              >
                <img src={Upload} alt="upload" />
                Upload an Image for the Trip?
                <input
                  type="file"
                  id="upload"
                  hidden
                  onChange={handleImageChange}
                />
              </label>
            )}
            <input
              type="file"
              id="upload"
              hidden
              onChange={handleImageChange}
            />
          </div>
        </div>
      </Modal>
      <Modal
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        title="Delete Trip"
        size="sm"
      >
        <p className="py-4">Are you sure you want to delete the trip?</p>
        <div
          className="mt-2 d-flex alifn-items-center justify-content-end"
          style={{ gap: 20 }}
        >
          <button className="btn-outlined" onClick={() => setDeleteOpen(false)}>
            Cancel
          </button>
          <button className="btn-contained" onClick={deleteTrip}>
            Confirm
          </button>
        </div>
      </Modal>
    </div>
  );
};
export default Alltrips;
